import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
var propTypes = {
  /**
  * Set IconTile content alignment.
  * One of: "left", "center".
  */
  align: PropTypes.oneOf(['left', 'center'])
};
var IconTile = createComponent({
  displayName: 'IconTile',
  root: 'div',
  propTypes: propTypes,
  propConfig: {
    classNames: function classNames(props) {
      var classNameSet = new Set(['swan-icon-tile']);
      var _props$align = props.align,
          align = _props$align === void 0 ? 'center' : _props$align;
      if (align != 'center') classNameSet.add("swan-icon-tile-align-".concat(align));
      return classNameSet;
    }
  }
});
IconTile.defaultProps = {
  align: 'center'
};
export { IconTile };